$(function () {
  // ---------- //
  // Accordions //
  // ---------- //

  // Active States
  $('body').on('click', '.accordion-title', function () {
    $(this).parent().toggleClass('active')
  })

  // Positioning
  function positionAccordions() {
    const accordian = document.getElementById('product_accordion')
    const media_wrapper = document.getElementById('product_media_wrapper')
    const info_wrapper = document.getElementById('product_info_wrapper')
    if (window.innerWidth <= 1024) {
      info_wrapper.appendChild(accordian)
    } else {
      media_wrapper.appendChild(accordian)
    }
  }

  // Debounced window.resize event listener
  let timeout
  window.addEventListener('resize', function () {
    // clear the timeout
    clearTimeout(timeout)
    // start timing for event "completion"
    timeout = setTimeout(positionAccordions, 200)
  })

  // position on initial page load
  positionAccordions()

  // Image Preview

  // Populate the main media div
  // const firstMedia = $('.product__media-list.--custom > *:first-child img')
  // const firstMediaSrc = firstMedia.attr('src')
  // const firstMediaSrcSet = firstMedia.attr('srcset')
  // const firstMediaId = firstMedia.attr('data-media-id')
  // const firstModalId = firstMedia.closest('.custom-product__modal-opener').attr('data-modal')
  // $('.product-media-main .product__modal-opener').attr('data-modal', firstModalId)
  // $('.product-media-main button.product__media-toggle').attr('data-media-id', firstMediaId)
  // $('.product-media-main .product__media img').attr('src', firstMediaSrc)
  // $('.product-media-main .product__media img').attr('srcset', firstMediaSrcSet)

  // Hide thumnbails if there's only 1
  const mediaLength = $('.product__media-list.--custom .product__media').length
  if (mediaLength === 1) {
    $('.product__media-list.--custom').hide()
  }

  // When clicking thumbnails, repopulate the main media div
/*
  $(document).on('click', '.product__media-list.--custom .product__media img', function (e) {
    const src = $(this).attr('src')
    const srcset = $(this).attr('srcset')
    const mediaId = $(this).attr('data-media-id')
    const modalId = $(this).closest('.custom-product__modal-opener').attr('data-modal')
    //console.log(mediaId)
    //console.log(modalId)
    $('.product-media-main .product__modal-opener').attr('data-modal', modalId)
    $('.product-media-main button.product__media-toggle').attr('data-media-id', mediaId)
    $('.product-media-main .product__media img').attr('src', src)
    $('.product-media-main .product__media img').attr('srcset', srcset)
    $('.product__media-list.--custom .custom-product__modal-opener').removeClass('active')
    $(this).closest('.custom-product__modal-opener').addClass('active')
    //document.querySelector('.product-media-main').scrollIntoView({ behavior: 'smooth' })
  })
*/
  // Initialise Owl Carousel
  // $('.owl-carousel').owlCarousel({
  //   loop: false,
  //   margin: 0,
  //   nav: true,
  //   dots: false,
  //   rewind: false,
  //   lazyLoadEager: 15,
  //   slideBy: 5,
  //   items: 5,
  // })




  var bigimage = $(".product-media-main");
  var thumbs = $(".desktopThumbnails");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage.owlCarousel({
    items: 1,
    nav: false,
    autoplay: false,
    dots: true,
    loop: false,
    responsiveRefreshRate: 200,
    responsive: {
          0: {
              dots: true
          },
          700: {
              dots: false
          }

      }
  }).on("changed.owl.carousel", syncPosition);

  thumbs.on("initialized.owl.carousel", function() {
    thumbs.find(".owl-item").eq(0).addClass("current");
  }).owlCarousel({
    items: 4,
    dots: false,
    loop: false,
    nav: true,
    smartSpeed: 200,
    slideSpeed: 500,
    slideBy: 1,
    responsiveRefreshRate: 100
  }).on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    //if loop is set to false, then you have to uncomment the next line
    //var current = el.item.index;

    //to disable loop, comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs
    .find(".owl-item.active")
    .first()
    .index();
    var end = thumbs
    .find(".owl-item.active")
    .last()
    .index();

    // if (current > end) {
    //   thumbs.data("owl.carousel").to(current, 100, true);
    // }
    // if (current < start) {
    //   thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    // }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });



  
})
